import { NavLink } from "react-router-dom";
import { Activity, Bot, FolderGit2, LayoutDashboard, ListChecks, MessageSquare, Settings } from "lucide-react";
import { cn } from "@/lib/utils";

type NavItem = {
  to: string;
  label: string;
  icon: React.ComponentType<{ className?: string }>;
};

// Sidebar nav items — Dashboard is the primary landing page.
const items: NavItem[] = [
  { to: "/dashboard", label: "Dashboard", icon: LayoutDashboard },
  { to: "/projects", label: "Projects", icon: FolderGit2 },
  { to: "/agents", label: "Agents", icon: Bot },
  { to: "/events", label: "Events", icon: Activity },
  { to: "/sessions", label: "Sessions", icon: MessageSquare },
  { to: "/runs", label: "Runs", icon: ListChecks },
  { to: "/settings", label: "Settings", icon: Settings },
];

export function AppSidebar() {
  return (
    <aside className="flex h-screen w-60 shrink-0 flex-col border-r border-sidebar-border bg-sidebar text-sidebar-foreground">
      <div className="flex h-14 items-center gap-2 border-b border-sidebar-border px-4">
        <img
          src="/icon.png"
          alt=""
          aria-hidden="true"
          className="h-7 w-7 rounded-md object-contain"
        />
        <span className="text-sm font-semibold tracking-tight">bee</span>
      </div>
      <nav className="flex-1 space-y-1 px-2 py-4">
        {items.map(({ to, label, icon: Icon }) => (
          <NavLink
            key={to}
            to={to}
            className={({ isActive }) =>
              cn(
                "flex items-center gap-3 rounded-md px-3 py-2 text-sm font-medium transition-colors",
                isActive
                  ? "bg-sidebar-accent text-sidebar-accent-foreground"
                  : "text-sidebar-foreground/80 hover:bg-sidebar-accent/60 hover:text-sidebar-accent-foreground",
              )
            }
          >
            <Icon className="h-4 w-4" />
            <span>{label}</span>
          </NavLink>
        ))}
      </nav>
      <div className="border-t border-sidebar-border px-4 py-3 text-xs text-sidebar-foreground/60">
        bee dashboard
      </div>
    </aside>
  );
}
